import "./index.scss";

import Container from "../../../components/Layout/Container"
import { Typography } from "antd";

const { Title, Paragraph } = Typography

export const FounderMessage: React.FC = () => {
    return (
        <section className="founder-message">
            <Container>
                <Title className="section-title" style={{ textAlign: 'center' }}>
                    A Message from Our Founder
                </Title>
                <div className="founder-message__content">
                    <div className="founder-message__content__wrapper">
                        <Paragraph className="founder-message__content__wrapper--text">
                            I know what it feels like to be lost. To search endlessly for clarity, for guidance, for someone who truly understands. I’ve been there — scrolling through self-help content, trying to piece together advice that never quite fit. I struggled to find the right mentor, the right coach, the right answers. And with ADHD, deep-diving into books or long-winded courses felt impossible.
                            <br />
                            <br />
                            That’s why, together with field experts, I built Moodra App — not as another self-help tool, but as a compass for those who feel stuck. A place where you can uncover what’s holding you back, gain real, personalized insights, and finally move forward with confidence.
                            <br />
                            <br />
                            If you’re here, know this: you are seen, you are heard, and you are not alone. This is your journey, and we’re here to help you take the next step — one that’s right for you.
                        </Paragraph>
                        <img
                            src="/images/founder.png"
                            alt="With Love, Aytaj"
                            width={184}
                            height={137}
                        />
                    </div>
                    <Paragraph className="founder-message__content__wrapper--text" style={{ marginTop: '12px', marginBottom: '0px !important' }}>
                        Founder & CEO, Moodra App
                    </Paragraph>
                </div>
            </Container>
        </section>
    )
}